module.exports = __webpack_public_path__ + "static/media/WA.1de8da77.png";